// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__13-Jp","content":"LoadingAlert_content__1x-DH"};